import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IAttributes } from 'src/app/models/IAttributes';
import { IClaimCodeMaster } from 'src/app/models/IClaimCodeMaster';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { IInsPlaneNames } from 'src/app/models/IInsPlaneNames';
import { IInsuranceCarriers } from 'src/app/models/IInsuranceCarriers';
import { IInsuranceDetails } from 'src/app/models/IInsuranceDetails';
import { IInsuranceStatus } from 'src/app/models/IInsuranceStatus';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessage } from 'src/app/models/IMedicationHistoryDTO';
import { MessageInbox } from 'src/app/models/IMessaging';
import { IPatientPortaInformation } from 'src/app/models/IPatientPortaInformation';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { SharedService } from 'src/app/Sharedservice/SharedService';

@Component({
  selector: 'app-pp-insurance-request',
  templateUrl: './pp-insurance-request.component.html',
  styleUrls: ['./pp-insurance-request.component.css']
})
export class PPInsuranceRequestComponent implements OnInit {

  PatientRequestInformationForm: FormGroup;
  personalInfo: IPersonalInfo;

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private messageService: MessagesService, private router: Router,
    private route: ActivatedRoute, private rxService: RxService, private bannerService: PatientBannerService,
    private sharedService: SharedService, public dialog: MatDialog
    , private personalService: PersonalInfoService, private _datePipe: DatePipe,
    private schedulerservice: SchedularServiceService) {
    // this.getPeresonalInfoByInsurance(1202)
    // this.getPeresonalInfo(1202)
    this.personalDropDownsBinding();

  }
  public linkID: number;
  public insuranceId: number;
  public requestType: number;
  ngOnInit() {
    ;
    this.PatientRequestInformationForm = this.formBuilder.group({
      rejectNotes: ['', Validators.required],
      rejectReason: [''],

    })
    this.linkID = Number(this.route.snapshot.paramMap.get('linkId'));
    this.insuranceId = Number(this.route.snapshot.paramMap.get('insuranceId'));
    this.requestType = Number(this.route.snapshot.paramMap.get('RequestType'));
    //this.getPatientRequestDetails(this.linkID);
    if (this.insuranceId != 0 && this.insuranceId != undefined && this.insuranceId != null) {
      this.isDisabledExistingdata = true;
    } else {
      this.isDisabledExistingdata = false;
    }
  }
  getPeresonalInfo(id: number) {
    this.personalService.getPersonalInfo(id)
      .subscribe(
        (personal: IPersonalInfo) => {
          this.personalInfo = personal;
        },
        (err: any) => console.log(err)
      );
  }
  lstInsRequest: IInsuranceDetails;
  lstInsRequestUpdate: IInsuranceDetails;
  isDisableRejectReason: boolean = false;
  isVisableRejectreason: boolean = false;
  isVisableRejectedBy: boolean = false;
  isDisableDemographicsbutton: boolean = false;
  rejectedBy: string = '';
  rejectedDate: string = '';

  maxChars = 230;
  charCount = '';
  isPatientStatus: boolean = false;
  patientId: number = 0;
  hideRejectbutton: boolean = true;
  hideRejectReason: boolean = true;
  rejectNotes: string = '';
  public lstattrbutes: IAttributes[];
  public lstGender: IAttributes[];
  public lstLocations: ILocationDetails[];
  public lstrelations: IAttributes[];
  public lstInsMasters: IInsuranceStatus[];
  public lstInslevels: IInsuranceStatus[];
  public lstInsStatus: IAttributes[];
  public lstPayerName: IInsuranceCarriers[];
  public lstDisplayInsDetails: IInsuranceCarriers[];
  public lstPayerClass: IInsuranceStatus[];
  public lstPayerType: IInsuranceStatus[];
  public lstPlaneName: IInsuranceStatus[];
  public lstInsTypeCode: IInsuranceStatus[];
  public lstInsRelation: IClaimCodeMaster[];
  public lstEligibility: IInsuranceStatus[];
  public lstGuarGender: IAttributes[];
  public lstInsPlaneNames: IInsPlaneNames[];
  public lstPlaneNames: IInsPlaneNames[];
  isDisabledExistingdata: boolean = true;
  personalDropDownsBinding() {
    ;
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
    this.personalService.getInsMasters().subscribe(data => {
      this.lstInsMasters = data;
      this.lstInslevels = this.lstInsMasters.filter((attr: IInsuranceStatus) => attr.insuranceStatusType === 'InsuranceType');
      this.lstPayerType = this.lstInsMasters.filter((attr: IInsuranceStatus) => attr.insuranceStatusType === 'PayerType');
      this.lstPayerClass = this.lstInsMasters.filter((attr: IInsuranceStatus) => attr.insuranceStatusType === 'PayerClass');
      this.lstInsTypeCode = this.lstInsMasters.filter((attr: IInsuranceStatus) => attr.insuranceStatusType === 'Insurance Type Code');
      this.lstEligibility = this.lstInsMasters.filter((attr: IInsuranceStatus) => attr.insuranceStatusType === 'EligibilityType');

    });
    this.personalService.getInsCarriers().subscribe(data => {
      this.lstPayerName = data.filter(d => d.isActive === true);
    });
    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.lstGender = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '11');
      ;
      this.getPatientRequestInfoOriginal(this.linkID);
      // this.getPatientRequestDetails(11);
    });
    // this.personalService.getInsPlaneNamesInfo().subscribe(data => {
    //   this.lstInsPlaneNames = data;
    //   this.getPatientRequestDetails(this.linkID);
    // });
    this.personalService.getInsPlaneNamesInfo().subscribe(data => {
      this.lstInsPlaneNames = data;
      // this.getPeresonalInfoByInsurance(1)
      this.getPatientRequestDetails(this.linkID);
    });
    this.sharedService.getClaimCodes().subscribe(data => {
      this.lstInsRelation = data.filter((ccodes: IClaimCodeMaster) => ccodes.attributeType === 'Relation' && ccodes.codeType === 'Both');
      this.lstInsRelation = this.lstInsRelation.filter((t, n, a) => a.findIndex(x => x.description === t.description) === n);
    });
  }
  personalInfoInsurance: IPersonalInfo;
  getPeresonalInfoByInsurance(id: number) {
    ;
    this.personalService.getPersonalInfoByInsurance(id)
      .subscribe(
        (personal: IPersonalInfo) => {
          this.personalInfoInsurance = personal;
        },
        (err: any) => console.log(err)
      );
  }
  PayerName: string = '';
  public PlanName: string = '';
  AcceptAssignment: string = "";
  PayerNameUpdate: string = '';
  public PlanNameUpdate: string = '';
  AcceptAssignmentUpdate: string = "";


  getPatientRequestInfoOriginal(linkId: number) {
    ;
    this.personalService.getInsuranceRequestInformationByInsId(this.insuranceId, linkId)
      .subscribe(
        (dataRef: any) => {
          ;
          this.lstInsRequest = dataRef;
          if (dataRef.length > 0 && dataRef != undefined && dataRef != null)



            if (this.lstEligibility.length != 0) {
              var eligibilitylst = this.lstEligibility.filter(x => x.insuranceStatusId === this.lstInsRequest.eligibilityCheck)
              if (eligibilitylst.length != 0)
                this.AcceptAssignment = eligibilitylst[0].insuranceStatusName;
            }
          ;
          var plan = this.lstInsPlaneNames.filter(x => Number(x.planId) == Number(this.lstInsRequest.planName));
          if (plan.length != 0) {
            this.PlanName = plan[0].planName;
          }
          else {
            this.PlanName = '';
          }
          var insPayer = this.lstPayerName.filter(x => Number(x.insuranceCarrierId) == Number(this.lstInsRequest.insuranceCarrierId));
          if (insPayer.length != 0) {
            this.PayerName = insPayer[0].insuranceName;
          }
          else {
            this.PayerName = '';
          }
        },
        (err: any) => {
          console.log(err);
        });
  }

  getPatientRequestDetails(linkID: number) {
    ;
    this.personalService.getInsuranceRequestInformationByLinkId(linkID)
      .subscribe(
        (dataRef: any) => {
          ;
          this.lstInsRequestUpdate = dataRef;

          if (this.lstInsRequestUpdate.requestStatus == 'Rejected') {
            if (this.lstInsRequestUpdate.comments == null || this.lstInsRequestUpdate.comments == "") {
              this.isDisableRejectReason = false;
            } else {
              this.hideRejectbutton = false;
              this.hideRejectReason = true;
              this.PatientRequestInformationForm.patchValue({
                rejectNotes: this.lstInsRequestUpdate.comments,
                rejectReason: true
              })
              this.rejectNotes = this.lstInsRequestUpdate.comments;
              this.isVisableRejectedBy = true;
              this.charCount = this.lstInsRequestUpdate.comments;
              this.rejectedBy = this.lstInsRequestUpdate.rejectedBy + ' ' + this.lstInsRequestUpdate.rejectedOn;
              this.rejectedDate = this.lstInsRequestUpdate.rejectedOn;
              this.isVisableRejectreason = true;
              this.isDisableRejectReason = true;
              this.isDisableDemographicsbutton = true;

            }
          }
          if (this.lstInsRequestUpdate.requestStatus === 'Completed') {
            this.hideRejectbutton = false;
            this.hideRejectReason = false;
            this.isPatientStatus = true;

            this.PatientRequestInformationForm.patchValue({
              rejectReason: false
            })
          }
          if (dataRef != undefined && dataRef != null)

            // if (dataRef.length > 0 && dataRef.length != undefined) {

            if (this.lstEligibility.length != 0) {
              var eligibilitylst = this.lstEligibility.filter(x => x.insuranceStatusId === this.lstInsRequestUpdate.eligibilityCheck)
              if (eligibilitylst.length != 0)
                this.AcceptAssignmentUpdate = eligibilitylst[0].insuranceStatusName;
            }
          ;
          var plan = this.lstInsPlaneNames.filter(x => Number(x.planId) == Number(this.lstInsRequestUpdate.planName));
          if (plan.length != 0) {
            this.PlanNameUpdate = plan[0].planName;
          }
          else {
            this.PlanNameUpdate = '';
          }
          var insPayer = this.lstPayerName.filter(x => Number(x.insuranceCarrierId) == Number(this.lstInsRequestUpdate.insuranceCarrierId));
          if (insPayer.length != 0 && insPayer != undefined) {
            this.PayerNameUpdate = insPayer[0].insuranceName;
          }
          else {
            this.PayerNameUpdate = '';
          }

        },
        (err: any) => {
          console.log(err);
        });
  }
  onClick_navigateToUpdateInsurance(insType: string) {
    if (insType === "updateInsurance") {

      //this.router.navigate(['/Demographics/Personal', this.linkID, 'Portal']);
      //alert(element.patientId)
      sessionStorage.setItem("demoheaderVisibility", "true");
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      CommonComponents.demoheaderVisibility = true;
      CommonComponents.patientId = this.lstInsRequestUpdate.patientId;
      this.bannerService.toggle(CommonComponents.patientId);
      sessionStorage.setItem("patientId", CommonComponents.patientId.toString());
      // sessionStorage.setItem("patientName", this.lstInsRequestUpdate.guarantorName.toString());
      this.router.navigate(['Demographics/EditInsuranceForm', this.insuranceId, this.linkID, 'Portal']); //, insuranceDetails.insuranceId
      // if (selectedRow && selectedRow != undefined) {
      // CommonComponents.patientId = element.patientId;
      //   CommonComponents.patientName = selectedRow.patName;
      //   this.bannerService.toggle(selectedRow.patId);
      //   CommonComponents.demoheaderVisibility = true;
      //   sessionStorage.setItem("patientId", selectedRow.patId.toString());
      //   sessionStorage.setItem("patientName", selectedRow.patName);
      //   this.router.navigateByUrl('Demographics/Personal');
      // }

    } else if (insType === "newInsurance") {
      sessionStorage.setItem("demoheaderVisibility", "true");
      CommonComponents.demoheaderVisibility = true;
      CommonComponents.patientId = this.lstInsRequestUpdate.patientId;
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      this.bannerService.toggle(CommonComponents.patientId);
      sessionStorage.setItem("patientId", CommonComponents.patientId.toString());
      // sessionStorage.setItem("patientName", this.lstInsRequestUpdate.guarantorName);
      this.router.navigate(['Demographics/Insurance', this.linkID, 'Portal']);
    }
  }
  onClick_backToMessages() {
    // this.router.navigate(['messageInbox']);
    //this.router.navigate(['tasksandmessages']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }
  rejectRequestInfo: MessageInbox;
  onClick_ReasonForReject() {
    this.rejectRequestInfo = this.PatientRequestInformationForm.value;
    this.rejectRequestInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.rejectRequestInfo.comments = this.PatientRequestInformationForm.value.rejectNotes;
    this.rejectRequestInfo.linkId = this.linkID.toString();
    this.rejectRequestInfo.status = 'Rejected';
    this.rejectRequestInfo.requestType = this.requestType.toString();
    if (this.PatientRequestInformationForm.value.rejectNotes != '') {
      this.personalService.updatePatientRequestInformationByLinkId(this.rejectRequestInfo)
        .subscribe(
          (result: any) => {
            this.toastr.success(result)
            this.getPatientRequestDetails(this.linkID);
          },
          (err: any) => {
            console.log(err);
          });
    }


  }

  changeReasonforReject(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = true;
      this.isDisableDemographicsbutton = true;

    }
    else {
      this.PatientRequestInformationForm.patchValue({
        rejectNotes: ''
      })
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
    }
  }
}

